import styled from 'styled-components'
import BaseListPublicationItem from '../ListPublicationItem'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const ListPublicationItem = styled(BaseListPublicationItem)`
  &:nth-child(odd) {
    background: ${({ theme }) => theme.colors.background.secondary.B};
  }
`
